import { MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import {
  type ScheduleFrequencyCustom,
  ScheduleFrequencyEnum,
  type ScheduleFrequencyMonthly,
  type ScheduleFrequencyWeekly,
} from '@ulysses-inc/harami_api_client'
import type { FormikErrors, FormikTouched } from 'formik'
import type React from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import {
  SCHEDULE_EVERY_MAX,
  SCHEDULE_EVERY_MIN,
} from 'src/features/schedules/scheduleFrequencyLimits'

interface OwnProps {
  frequency: ScheduleFrequencyEnum | null
  frequencyWeekly?: ScheduleFrequencyWeekly
  frequencyMonthly?: ScheduleFrequencyMonthly
  frequencyCustom?: ScheduleFrequencyCustom
  touched: FormikTouched<any>
  errors: FormikErrors<any>
  submitCount: number
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
}

const FrequencySelectOptionInDuration: React.FC<OwnProps> = (
  props: OwnProps,
) => {
  return (
    <Stack spacing={1}>
      <Select
        value={props.frequency ?? ''}
        onChange={e => {
          props.setFieldValue('frequency', e.target.value)
        }}
        sx={{ width: '100%' }}
        size="small"
      >
        <MenuItem value={ScheduleFrequencyEnum.Weekly}>週単位</MenuItem>
        <MenuItem value={ScheduleFrequencyEnum.Monthly}>月単位</MenuItem>
        <MenuItem value={ScheduleFrequencyEnum.Custom}>カスタム</MenuItem>
      </Select>
      {props.submitCount > 0 && (
        <Stack>
          <FormikErrorMessage name="frequency" errors={props.errors} />
        </Stack>
      )}
      {props.frequency === ScheduleFrequencyEnum.Weekly && (
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <TextField
              type="number"
              value={props.frequencyWeekly?.every ?? ''}
              onChange={e => {
                const value =
                  e.target.value === '' ? undefined : Number(e.target.value)
                props.setFieldValue('frequencyWeekly', {
                  ...props.frequencyWeekly,
                  every: value,
                  dayOfWeeks: [],
                })
              }}
              size="small"
              sx={{ flex: 0.5 }}
              slotProps={{
                htmlInput: {
                  min: SCHEDULE_EVERY_MIN,
                  max: SCHEDULE_EVERY_MAX.weekly,
                },
              }}
            />
            <Typography>週間ごと</Typography>
          </Stack>
          {props.submitCount > 0 && (
            <Stack>
              <FormikErrorMessage
                name="frequencyWeekly.every"
                errors={props.errors}
              />
            </Stack>
          )}
        </Stack>
      )}
      {props.frequency === ScheduleFrequencyEnum.Monthly && (
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <TextField
              type="number"
              value={props.frequencyMonthly?.every ?? ''}
              onChange={e => {
                const value =
                  e.target.value === '' ? undefined : Number(e.target.value)
                props.setFieldValue('frequencyMonthly', {
                  ...props.frequencyMonthly,
                  every: value,
                })
              }}
              sx={{ flex: 0.5 }}
              size="small"
              slotProps={{
                htmlInput: {
                  min: SCHEDULE_EVERY_MIN,
                  max: SCHEDULE_EVERY_MAX.monthly,
                },
              }}
            />
            <Typography>ヵ月ごと</Typography>
          </Stack>
          {props.submitCount > 0 && (
            <Stack>
              <FormikErrorMessage
                name="frequencyMonthly.every"
                errors={props.errors}
              />
            </Stack>
          )}
        </Stack>
      )}
      {props.frequency === ScheduleFrequencyEnum.Custom && (
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <TextField
              type="number"
              value={props.frequencyCustom?.every ?? ''}
              onChange={e => {
                const value =
                  e.target.value === '' ? undefined : Number(e.target.value)
                props.setFieldValue('frequencyCustom', {
                  ...props.frequencyCustom,
                  every: value,
                })
              }}
              sx={{ flex: 0.5 }}
              size="small"
              slotProps={{
                htmlInput: {
                  min: SCHEDULE_EVERY_MIN,
                  max: SCHEDULE_EVERY_MAX.custom,
                },
              }}
            />
            日ごと
          </Stack>
          {props.submitCount > 0 && (
            <Stack>
              <FormikErrorMessage
                name="frequencyCustom.every"
                errors={props.errors}
              />
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default FrequencySelectOptionInDuration
